export default "__VITE_ASSET__CC8w2Iqi__"